import React from "react"
import * as style from "./TileGrid.module.scss"

const TileGrid = ({ children, rows }) => (
  <section className={`${style.tileGrid} ${rows ? `rows-${rows}` : ''}`}>
    {children}
  </section>
)

export default TileGrid
